var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"thankyou"},[_vm._v("Please Wait Initializing Server...")]),_vm._v(" "),_c('aside',{staticClass:"hidden-block",attrs:{"id":"hidden-aside"},on:{"dblclick":_vm.gotoSettingLogin}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-569a4a90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/kiosk/startPage.vue
// module id = 1342
// module chunks = 173